// Egen modul så att komponenter som laddar om sidan kan testas utan att
// jsdom:s window.location behöver skrivas över.
export const reloadPage = () => {
  window.location.reload();
};
